import { useT } from "@repo/transifex";
import { useVatLabel } from "~/hooks/use-vat-label";

import { SalesTableSection } from "./SalesTableSection";
import { type SalesPerUsersData } from "./types";

type SalesPerUsersSectionProps = {
  data: SalesPerUsersData;
};

export const SalesPerUsersSection = ({ data }: SalesPerUsersSectionProps) => {
  const t = useT();
  const { vatLabel } = useVatLabel();

  return (
    <SalesTableSection
      title={t("Sales per operators (incl. {vatLabel})", { vatLabel })}
      nameLabel={t("Operator")}
      data={data}
    />
  );
};
